var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlaeche(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54.616,
    height: 54.616,
    viewBox: "0 0 54.616 54.616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Pfad_161",
    x: 0,
    y: 0,
    width: 54.616,
    height: 54.616,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#57b0b6",
    floodOpacity: 0.298
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flaeche",
    transform: "translate(9 5.836)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -9, -5.84)",
    filter: "url(#Pfad_161)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_161-2",
    "data-name": "Pfad 161",
    d: "M106.6,18.308A18.308,18.308,0,1,0,88.3,36.616,18.308,18.308,0,0,0,106.6,18.308",
    transform: "translate(-60.99 6)",
    fill: "#dbf1f7"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_146",
    "data-name": "Pfad 146",
    d: "M147.172,31.612a.525.525,0,1,1,0-1.049.525.525,0,1,1,0,1.049",
    transform: "translate(-120.216 -27.658)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_147",
    "data-name": "Pfad 147",
    d: "M145.359,51.963a.528.528,0,0,1,.532-.525.525.525,0,1,1,0,1.05.528.528,0,0,1-.532-.525",
    transform: "translate(-119.056 -46.549)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_148",
    "data-name": "Pfad 148",
    d: "M125.678,19.039a.62.62,0,1,1,0,1.239.62.62,0,1,1,0-1.239",
    transform: "translate(-100.668 -17.229)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_149",
    "data-name": "Pfad 149",
    d: "M17.406,276v2.281a1.525,1.525,0,0,1-1.521,1.521H7.521A1.525,1.525,0,0,1,6,278.281V276H17.406Z",
    transform: "translate(7.057 -249.767)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_150",
    "data-name": "Pfad 150",
    d: "M165.675,32.027a.433.433,0,0,1-.441.426.426.426,0,1,1,0-.852.433.433,0,0,1,.441.426",
    transform: "translate(-136.65 -28.597)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_151",
    "data-name": "Pfad 151",
    d: "M17.406,172v9.885H6V172H17.406Z",
    transform: "translate(7.057 -155.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_152",
    "data-name": "Pfad 152",
    d: "M163.64,62.961a.43.43,0,1,1-.441.433.435.435,0,0,1,.441-.433",
    transform: "translate(-135.201 -56.977)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_153",
    "data-name": "Pfad 153",
    d: "M17.406,118.912v2.41H6v-2.41a1.525,1.525,0,0,1,.449-1.08L8.281,116h6.843l1.833,1.833a1.525,1.525,0,0,1,.449,1.08",
    transform: "translate(7.057 -104.974)",
    fill: "#73c9e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_154",
    "data-name": "Pfad 154",
    d: "M126.309,40.547a.626.626,0,0,1-.631.616.62.62,0,1,1,.631-.616",
    transform: "translate(-100.668 -36.128)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_155",
    "data-name": "Pfad 155",
    d: "M146.432,10.041a.534.534,0,0,1-.54.525.525.525,0,1,1,0-1.05.534.534,0,0,1,.54.525",
    transform: "translate(-119.057 -8.612)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_156",
    "data-name": "Pfad 156",
    d: "M163.64,0a.434.434,0,0,1,.441.426.441.441,0,0,1-.882,0A.434.434,0,0,1,163.64,0",
    transform: "translate(-135.201 0)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_157",
    "data-name": "Pfad 157",
    d: "M102.73,28.563a.715.715,0,1,1-.73.714.722.722,0,0,1,.73-.714",
    transform: "translate(-79.819 -25.848)",
    fill: "#979faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_158",
    "data-name": "Pfad 158",
    d: "M36.844,68v4.562H30V68h6.843Z",
    transform: "translate(-14.662 -61.537)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_159",
    "data-name": "Pfad 159",
    d: "M49.8,17.323H46V12h3.8v1.293a.913.913,0,0,0-.509-.152,1.149,1.149,0,0,0,0,2.281.976.976,0,0,0,.509-.152v2.053Z",
    transform: "translate(-29.141 -10.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_160",
    "data-name": "Pfad 160",
    d: "M11.931,17.885l-1.666-1.666V11.893a.57.57,0,0,0-.57-.57h-.95V6.57A.57.57,0,0,0,8.174,6h-3.8a.57.57,0,0,0-.57.57v4.752h-.95a.57.57,0,0,0-.57.57v4.326L.616,17.885A2.084,2.084,0,0,0,0,19.368V33.944a2.093,2.093,0,0,0,2.091,2.091h8.364a2.093,2.093,0,0,0,2.091-2.091V19.368a2.084,2.084,0,0,0-.616-1.483M4.942,7.141H7.6v.574a1.092,1.092,0,0,0-.95,1.137A1.1,1.1,0,0,0,7.6,9.988v1.334H4.942ZM3.422,12.463h5.7v3.422h-5.7Zm7.984,8.744H3.612a.57.57,0,0,0,0,1.141h7.794v8.744H3.612a.57.57,0,1,0,0,1.141h7.794v1.711a.952.952,0,0,1-.95.95H2.091a.952.952,0,0,1-.95-.95V19.368a.951.951,0,0,1,.281-.676l1.666-1.666H9.459l1.666,1.666a.951.951,0,0,1,.281.676Z",
    transform: "translate(12.487 -5.43)",
    fill: "#303e58"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlaeche);
export default __webpack_public_path__ + "static/media/flaeche.1afdab01d760bc5d5bce1d92b3f803ed.svg";
export { ForwardRef as ReactComponent };